import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/shobhitsinha04'
      className='link footer__link'
    >
    Shobhit Sinha - (217) 200 5154 - shobhit.sinha2004@gmail.com
    </a>
  </footer>
)

export default Footer
